import { AssetTypeSearchFilterEnum } from '../searchParameters';
import type { SearchParameterScope } from './siteExclusions';

/**
 * Named slices of searches a site can offer a parameter on.
 *
 * A site config entry points a parameter at one of these when that site
 * disagrees with the shared asset-type and family rule. The lists name
 * searches, not a site, so either site can use one.
 */

// Image, film, and image-and-film, whatever the family.
export const IMAGE_FILM_OR_BOTH_SEARCHES: readonly SearchParameterScope[] = [
  {
    assettypes: [
      AssetTypeSearchFilterEnum.IMAGE,
      AssetTypeSearchFilterEnum.FILM,
      AssetTypeSearchFilterEnum.IMAGE_AND_FILM,
    ],
  },
];

// The asset types whose searches include still images.
export const IMAGE_INCLUDING_ASSET_TYPES = [
  AssetTypeSearchFilterEnum.IMAGE,
  AssetTypeSearchFilterEnum.IMAGE_AND_FILM,
];

// Film searches, whatever the family.
export const FILM_SEARCHES: readonly SearchParameterScope[] = [
  { assettypes: [AssetTypeSearchFilterEnum.FILM] },
];

// All asset types, whatever the family.
export const ALL_ASSET_TYPE_SEARCHES: readonly SearchParameterScope[] = [
  {
    assettypes: [
      AssetTypeSearchFilterEnum.IMAGE,
      AssetTypeSearchFilterEnum.FILM,
      AssetTypeSearchFilterEnum.IMAGE_AND_FILM,
      AssetTypeSearchFilterEnum.VIDEO_TEMPLATE,
    ],
  },
];
